import React, { Suspense } from "react";
import Root from "./components/root";
import RecoveryNetworkLanding from "./components/root/RecoveryNetworkLanding";
import theme from "./theme";
import { ThemeProvider } from "@material-ui/styles";
import { MuiThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import FullScreenLoading from "./components/FullScreenLoading";
import { parseHostname } from "./hostname";
import { IS_CRABGEAR_BRANDING } from "./brand/config";

// if (process.env.NODE_ENV === "production") {
//   Sentry.init({dsn: "https://2b1d158c18d349168800d88b4f699dab@sentry.io/1858762"});
// }

const AuthPage = React.lazy(() => import("./components/auth/AuthPage"));
const ProjectApp = React.lazy(() => import("./ProjectApp"));

const { isApex: isRootDomain, subdomain } = parseHostname();

if (subdomain === "sightings") {
  window.location.href = "https://ee.kobotoolbox.org/xqi6e2Se/";
}

const App = () => {
  return (
      <MuiThemeProvider theme={theme}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <BrowserRouter>
            {isRootDomain || subdomain === "www" ? (
              IS_CRABGEAR_BRANDING ? <Root /> : <RecoveryNetworkLanding />
            ) : (
              <Suspense fallback={<FullScreenLoading />}>
                <Switch>
                  <Route path="/auth/:state" component={AuthPage} />
                  <Route path="/" component={ProjectApp} />
                </Switch>
              </Suspense>
            )}
          </BrowserRouter>
        </ThemeProvider>
      </MuiThemeProvider>
  );
};

export default App;
